<div class="alert d-flex align-items-center p-5 mb-10" [ngClass]="alertClass">
  @if (!hideicon) {
    <span class="svg-icon svg-icon-2hx text-white me-4">
      <bws-mdi [name]="icon" class="fs-1" [ngClass]="iconClass" />
    </span>
  }
  <div class="d-flex flex-column w-100">
    <div>
      <ng-content></ng-content>
    </div>
  </div>
</div>
